(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gd-technical-support"]) return;
  try {
    
(() => {
  const dialog = document.getElementById('GDSupportDialog');
  const launcher = document.querySelector('[data-gd-support-open]');
  if (!dialog || !launcher || typeof dialog.show !== 'function') return;
  const dismissedKey = 'gd-support-dismissed';
  let dismissed = false;
  try { dismissed = sessionStorage.getItem(dismissedKey) === 'true'; } catch {}
  const open = () => {
    if (dialog.open) return;
    dialog.show();
    launcher.setAttribute('aria-expanded', 'true');
  };
  launcher.addEventListener('click', () => { if (dialog.open) dialog.close(); else open(); });
  dialog.addEventListener('keydown', event => { if (event.key === 'Escape') { dialog.close(); launcher.focus(); } });
  dialog.querySelectorAll('[data-gd-support-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('close', () => {
    launcher.setAttribute('aria-expanded', 'false');
    dismissed = true;
    try { sessionStorage.setItem(dismissedKey, 'true'); } catch {}
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  const result = dialog.querySelector('[data-gd-support-result]');
  if (result) {
    open();
    if (result.dataset.gdSupportResult === 'success') launcher.hidden = true;
    return;
  }
  if (dialog.dataset.autoEnabled === 'true' && !dismissed && !window.Shopify?.designMode) open();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gd-v2-header"]) return;
  try {
    
document.addEventListener('click',event=>{document.querySelectorAll('.gd-nav-group[open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false;});});
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.gd-nav-group[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gd-v2-inquiry"]) return;
  try {
    
const gdQuery=new URLSearchParams(location.search);
document.querySelectorAll('[data-gd-source-url]').forEach(input=>{input.value=location.href.slice(0,1000);});
document.querySelectorAll('[data-gd-source-campaign]').forEach(input=>{const value=gdQuery.get('source');if(value)input.value=value.slice(0,120);});
[['[data-gd-utm-source]','utm_source'],['[data-gd-utm-medium]','utm_medium'],['[data-gd-utm-campaign]','utm_campaign'],['[data-gd-utm-content]','utm_content'],['[data-gd-utm-term]','utm_term']].forEach(([selector,key])=>{const value=gdQuery.get(key);if(value)document.querySelectorAll(selector).forEach(input=>{input.value=value.slice(0,250);});});
document.querySelectorAll('[data-gd-referrer]').forEach(input=>{if(document.referrer)input.value=document.referrer.slice(0,500);});
document.querySelectorAll('[data-gd-inquiry-product]').forEach(input=>{const value=gdQuery.get('product');if(value){input.value=value.slice(0,250);const form=input.closest('form');const name=form.querySelector('[data-gd-product-name]');const context=form.querySelector('[data-gd-product-context]');if(name&&context){name.textContent=input.value;context.hidden=false;}}});
document.querySelectorAll('[data-gd-inquiry-configuration]').forEach(input=>{const value=gdQuery.get('configuration');if(value){input.value=value.slice(0,500);const form=input.closest('form');const name=form.querySelector('[data-gd-configuration-name]');const context=form.querySelector('[data-gd-configuration-context]');if(name&&context){name.textContent=input.value;context.hidden=false;}}});
document.querySelectorAll('[data-gd-inquiry-sku]').forEach(input=>{const value=gdQuery.get('sku');if(value){input.value=value.slice(0,120);const form=input.closest('form');const name=form.querySelector('[data-gd-sku-name]');const context=form.querySelector('[data-gd-sku-context]');if(name&&context){name.textContent=input.value;context.hidden=false;}}});
document.querySelectorAll('[data-gd-inquiry-variant-id]').forEach(input=>{const value=gdQuery.get('variant_id');if(value)input.value=value.slice(0,120);});
document.querySelectorAll('[data-gd-hidden-customer-type]').forEach(input=>{const value=gdQuery.get('customer_type');if(value)input.value=value.slice(0,160);});
document.querySelectorAll('[data-gd-hidden-product-interest]').forEach(input=>{const value=gdQuery.get('interest');if(value)input.value=value.slice(0,180);});
document.querySelectorAll('[data-gd-hidden-project-stage]').forEach(input=>{const value=gdQuery.get('project_stage');if(value)input.value=value.slice(0,160);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gd-v2-product"]) return;
  try {
    
const gdOptionInputs=[...document.querySelectorAll('[data-gd-option]')];
const gdVariantNode=document.querySelector('[data-gd-variant-data]');
let gdVariants=[];
if(gdVariantNode){try{gdVariants=JSON.parse(gdVariantNode.textContent||'[]')}catch(e){gdVariants=[]}}
function gdSelectedVariant(){
  if(!gdOptionInputs.length)return null;
  const values=gdOptionInputs.map(input=>input.value);
  if(values.some(value=>!value))return null;
  return gdVariants.find(variant=>Array.isArray(variant.options)&&variant.options.every((value,index)=>value===values[index]))||null;
}
function gdUpdateSelectedSku(){
  const variant=gdSelectedVariant();
  const row=document.querySelector('[data-gd-selected-sku]');
  const value=document.querySelector('[data-gd-selected-sku-value]');
  if(row&&value){
    if(variant&&variant.sku){value.textContent=variant.sku;row.hidden=false}else{value.textContent='';row.hidden=true}
  }
}
gdOptionInputs.forEach(input=>input.addEventListener('change',gdUpdateSelectedSku));
document.querySelectorAll('[data-gd-config-link]').forEach(link=>{link.addEventListener('click',()=>{
  const selections=gdOptionInputs.filter(input=>input.value).map(input=>input.dataset.label+': '+input.value);
  const variant=gdSelectedVariant();
  const url=new URL(link.href,location.href);
  if(selections.length)url.searchParams.set('configuration',selections.join('; '));else url.searchParams.delete('configuration');
  if(variant&&variant.sku)url.searchParams.set('sku',variant.sku);else url.searchParams.delete('sku');
  if(variant&&variant.id)url.searchParams.set('variant_id',String(variant.id));else url.searchParams.delete('variant_id');
  link.href=url.href;
});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gd-v4-catalog"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.gd4-catalog').forEach(root=>{
  const cards=[...root.querySelectorAll('[data-gd-card]')];
  const tabs=[...root.querySelectorAll('[data-gd-category]')];
  const search=root.querySelector('[data-gd-search]');
  const voltage=root.querySelector('[data-gd-voltage]');const color=root.querySelector('[data-gd-color]');
  let category='all';
  const apply=()=>{
    const term=search.value.toLowerCase().trim();let count=0;
    cards.forEach(card=>{const show=(category==='all'||card.dataset.category===category)&&card.dataset.search.toLowerCase().includes(term)&&(!voltage.value||card.dataset.voltage.split(',').includes(voltage.value))&&(!color.value||card.dataset.color.split(' ')[0]===color.value);card.hidden=!show;if(show)count++;});
    tabs.forEach(tab=>tab.dataset.gdCategory===category?tab.setAttribute('aria-current','true'):tab.removeAttribute('aria-current'));
    const counter=root.querySelector('[data-gd-count]');counter.textContent=count+' '+counter.dataset.label;
    root.querySelector('[data-gd-empty]').hidden=count>0;
  };
  const fromUrl=()=>{const h=new URLSearchParams(location.search).get('category')||location.hash.slice(1);category=tabs.some(t=>t.dataset.gdCategory===h)?h:'all';apply();};
  tabs.forEach(tab=>tab.addEventListener('click',e=>{e.preventDefault();const u=new URL(location.href);u.searchParams.set('category',tab.dataset.gdCategory);u.hash='';history.replaceState(null,'',u.pathname+u.search);category=tab.dataset.gdCategory;apply();}));
  root.querySelector('[data-gd-reset]').addEventListener('click',()=>{search.value='';voltage.value='';color.value='';category='all';const u=new URL(location.href);u.searchParams.delete('category');history.replaceState(null,'',u.pathname);apply();search.focus();});
  voltage.addEventListener('change',apply);color.addEventListener('change',apply);search.addEventListener('input',apply);fromUrl();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
